import React from 'react'
import { Button } from 'react-bootstrap';
import { FaQuoteLeft, FaRegCircleUser } from 'react-icons/fa6';
import { MdOutlineStarPurple500, MdPerson } from 'react-icons/md';

const HomeTestimonial = () => {
    const services = [
        { icons: <FaRegCircleUser size={35} />, name: "Mohamed Benali", profession: "Passionné de navigation", description: `Louez une voiture chez notre agence de location avec un processus simple et rapide sans perturber votre productivité` },
        { icons: <FaRegCircleUser size={35} />, name: "Amina Khelifi", profession: "Voyageuse régulière", description: `Nos voitures sont toujours entretenues en bonne santé et propreté du moteur pour offrir une expérience de conduite plus confortable` },
        { icons: <FaRegCircleUser size={35} />, name: "Yassine Boukacem", profession: "Homme d'affaires", description: `Nos voitures sont toujours entretenues en bonne santé et propreté du moteur pour offrir une expérience de conduite plus confortable` }
    ];

    


    return (
        <div className="container-fluid" style={{ padding: "100px 0px 100px 0px" }}>
            <div className="container" style={{ display: "flex", flexDirection: "column", justifyContent: "center", }}>
                <div><h5 style={{ color: "#43B613", textAlign: "center" }}>NOTRE REVUE</h5></div>
                <div><h2 style={{ color: "#737373", textAlign: "center" }}>Ce qu{"'"}ils disent ? </h2></div>
                <div>
                    <p style={{ color: "#A6A6A6", textAlign: "center" }}>
                        Voici quelques commentaires de nos clients, soyez l'un d'entre eux
                    </p>
                </div>
            </div>

            {/*listes de vehoicule */}
            <div className="container" style={{ padding: "50px 10px 50px 10px" }}>

                <div className="row" style={{ justifyContent: "center" }} >
                    {
                        services.map((item) => {
                            return (
                                <div className="col-md-3 rounded-lg" style={{ border: "2px #42B711 solid", margin: "10px", overflow: "hidden", display: "flex", flexDirection: "column", alignContent: "center", padding: "20px 10px 20px 10px" }}>
                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                        <div>
                                            <div>
                                                <FaQuoteLeft style={{ color: "#43B613" }} size={30} /> {/* Symbole « */}
                                            </div>
                                        </div>
                                        <div>
                                            <MdOutlineStarPurple500 style={{ color: "#43B613" }} />
                                            <MdOutlineStarPurple500 style={{ color: "#43B613" }} />
                                            <MdOutlineStarPurple500 style={{ color: "#43B613" }} />
                                            <MdOutlineStarPurple500 style={{ color: "#43B613" }} />
                                            <MdOutlineStarPurple500 style={{ color: "#43B613" }} />
                                        </div>
                                    </div>
                                    <div style={{ padding: "10px", borderBottomLeftRadius: "5px", borderBottomRightRadius: "5px" }}>

                                        <div className="pt-2 pb-2" style={{ display: "flex", justifyContent: "space-between", }}>
                                            <div>
                                                <p style={{ color: "#A6A6A6" }}>{item.description}</p>
                                            </div>
                                        </div>
                                        <div style={{ padding: "5px 0px 0px 0px", display: "flex" }}>
                                            <div className="">
                                                {item.icons}
                                            </div>
                                            <div style={{ padding: "0px 0px 0px 10px" }}>
                                                <div>
                                                    <h6 style={{ color: "#737373", fontSize: "14px" }}>{item.name}</h6>
                                                </div>
                                                <div>
                                                    <p style={{ color: "#BFBFBF", fontSize: "12px" }}>{item.profession}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>

            {/* Bouton ensavoir plus */}
            {/* <div style={{ width:"100%", display: "flex", justifyContent: "center", margin: "30px 0px 0px 0px" }}>
                <Button type="button" style={{ padding: "10px 10px 10px 10px", color: "white", borderRadius: "30px", textAlign: "center", display: "flex", justifyContent: "center" }} variant="dark" className="">
                    <div style={{ display: "flex", justifyContent: "space-between", alignContent: "center" }}>
                        <div className="p-1"><span className="text-center"> Voir plus </span> </div>
                    </div>
                </Button>
            </div> */}

        </div>
    )
}

export default HomeTestimonial;
